/* tslint:disable */
/* eslint-disable */
export enum PaymentFrequency {
  None = 'None',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Annually = 'Annually',
  Other = 'Other'
}
